module.exports = __webpack_public_path__ + "static/media/services.cd42f24f.png";